import { Typography } from "@mui/material";
import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { MersetaLai } from "../../../../../Component/Model/Dto/WSP/MerSETALAI";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";
import { CurrencyFormatter } from "../../../../../Helpers/CurrencyFormatter";

interface organisationLAITrainingRows {
    startEndDate: string,
    beeCategory: string,
    interventionType: string,
    interventionTitle: string,
    courseName: string,
    attendees: JSX.Element,
    cost: string,
    actions: ActionType[];
}

interface organisationLAITrainingTable {
    columns: Array<TableColumn>;
    rows: Array<organisationLAITrainingRows>;
}

export function OrganisationLAITrainingDataTable(dataObject: MersetaLai[], deleteMerSETALAI: (setLAIId: number, courseName: string) => void, editMerSetaLai: (id: number) => void, handleRouteToAttendeeClick: (id: number) => void): organisationLAITrainingTable {

    function getActionsColumn(item: MersetaLai, index: number) {
        const actions: ActionType[] = [{
            key: index.toString(),
            label: 'Edit',
            action: () => {
                editMerSetaLai(item.id);
            },
            icon: {
                color: 'info',
                name: 'edit'
            }
        },
        {
            key: index.toString(),
            label: 'Delete',
            action: () => {
                deleteMerSETALAI(item.id!, item.courseName);
            },
            icon: {
                color: 'error',
                name: 'delete'
            }
        }]
        return actions;
    }

    const columns = [
        { Header: 'Start - End Date', accessor: 'startEndDate', id: 'startEndDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'BEE Category', accessor: 'beeCategory', id: 'beeCategory', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Intervention Type', accessor: 'interventionType', id: 'interventionType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Intervention Title', accessor: 'interventionTitle', id: 'interventionTitle', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Course Name', accessor: 'courseName', id: 'courseName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Attendees', accessor: 'attendees', id: 'attendees', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Cost (excl. VAT)', accessor: 'cost', id: 'cost', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, rightAlign: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },

    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: MersetaLai, index: number) => ({
            startEndDate: item.startEndDate,
            beeCategory: item.beeCategory,
            interventionType: item.interventionType,
            interventionTitle: item.interventionTitle,
            courseName: item.courseName,
            attendees: (
                <Typography variant="caption" fontWeight='regular' color="#007bff"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    handleRouteToAttendeeClick(item.id);
                }}>
                    {item.attendees}
                </Typography>
            ),
            cost: CurrencyFormatter(item.cost),
            actions: getActionsColumn(item, index)
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
